// Image utility functions for handling loading errors and fallbacks

export const handleImageError = (event) => {
  const img = event.target;
  
  // Add error class for styling
  img.classList.add('image-error');
  
  // Set fallback background
  img.style.backgroundColor = '#ffffff';
  img.style.border = '3px solid #000000';
  
  // Add placeholder content
  img.style.position = 'relative';
  
  // Create placeholder element
  const placeholder = document.createElement('div');
  placeholder.innerHTML = '👤';
  placeholder.style.cssText = `
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 60px;
    color: #666;
    pointer-events: none;
  `;
  
  // Remove any existing placeholder
  const existingPlaceholder = img.parentNode.querySelector('.image-placeholder');
  if (existingPlaceholder) {
    existingPlaceholder.remove();
  }
  
  // Add new placeholder
  placeholder.className = 'image-placeholder';
  img.parentNode.appendChild(placeholder);
};

export const handleImageLoad = (event) => {
  const img = event.target;
  
  // Remove error class
  img.classList.remove('image-error');
  
  // Remove placeholder if exists
  const placeholder = img.parentNode.querySelector('.image-placeholder');
  if (placeholder) {
    placeholder.remove();
  }
  
  // Reset styles
  img.style.backgroundColor = '';
  img.style.border = '';
  img.style.position = '';
};

export const setupImageHandlers = () => {
  // Setup handlers for all profile images (only actual img elements, not divs)
  const profileImages = document.querySelectorAll('.profile-img:not(.empty-profile)');
  
  profileImages.forEach(img => {
    // Remove existing handlers
    img.removeEventListener('error', handleImageError);
    img.removeEventListener('load', handleImageLoad);
    
    // Add new handlers
    img.addEventListener('error', handleImageError);
    img.addEventListener('load', handleImageLoad);
    
    // Check if image is already loaded or has error
    if (img.complete) {
      if (img.naturalWidth === 0) {
        handleImageError({ target: img });
      } else {
        handleImageLoad({ target: img });
      }
    }
  });
};

// Auto-setup when DOM is ready
if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupImageHandlers);
  } else {
    setupImageHandlers();
  }
} 